import { mediaQuery } from 'constants/ui';

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const sectionStyles = {
  padding: '24px',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: ({ palette }) => palette.shadow.m,
};

// On tablet the table is wider than its container and scrolls horizontally, so
// the rightmost Action column (which hosts the per-borrower "Needed" badge) would
// otherwise clip off-canvas. Pin it to the right edge — scoped to these page
// tables via customStyles, NOT the shared SimpleTable — so the completeness signal
// and row menu stay visible while the rest of the columns scroll under it.
export const tableWrapperStyles = {
  '.add-button': {
    '&.Mui-disabled': {
      opacity: 0.4,
    },
  },

  [mediaQuery.tablet]: {
    '& th:last-of-type, & td:last-of-type': {
      position: 'sticky',
      right: 0,
      zIndex: 1,
      backgroundColor: ({ palette }) => palette.background.paper,
      borderLeft: ({ palette }) => `1px solid ${palette.border.default}`,
    },
  },
};

// The Action cell hosts the row's modal opener; the "Needed" count badge sits
// beside it so the incomplete-field signal reads as part of the same affordance.
export const actionCellStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
};
